// extracted by mini-css-extract-plugin
export default {"EmptyDeals":"EmptyDeals_EmptyDeals__KpBXi","Title":"EmptyDeals_Title__aD4zM","Subtext":"EmptyDeals_Subtext__jgk9P"};